<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="AbrirJanela()" style="color: #DD6625 ; font-size: 32px">mdi-help-box</v-icon>
        </template>
        <span>Tutorial</span>
    </v-tooltip>    
</template>

<script>

export default {
    data: () => ({
        url: require('../../assets/images/notFound.jpeg')
    }),
    props:{
        link: null
    },
    methods:{
        AbrirJanela(){
            if(!this.link){
                this.$swal({
                    title: 'Em breve tutorial estará disponível!!!!',
                    width: 800,
                    heightAuto: true,
                    padding: '3em',
                    // background: `url(${this.url})`,
                    imageUrl: this.url,
                    customClass:{
                        title: 'dialogText',
                        confirmButton: 'dialogButton'
                    }

                })
            }
            else{
                window.open(this.link, '_blank').focus();
            }   
        }
    }
}
</script>

<style>
    .dialogText{
        color: black;
        /* background: rgba(0, 49, 95, 0.699); */
        /* padding: 15px; */
        /* border-radius: 10px; */
    }
    .dialogButton{
        color: rgb(255, 255, 255);
        background: rgba(0, 49, 95, 0.699);
        border-radius: 10px;
    }
</style>